import { useContext } from "react";

import { UploadSessionContext } from "./UploadSessionProvider";

import type { UploadSessionContextValue } from "./UploadSessionProvider";

export const useUploadSession = (): UploadSessionContextValue => {
  const value = useContext(UploadSessionContext);
  if (!value) {
    throw new Error(
      "useUploadSession must be used within an UploadSessionProvider"
    );
  }
  return value;
};
